import * as TYPES from "./prescribeTypes";

const INITIAL_STATE = {
  prescribe: {},
  selectedPrescribe: null,
  showLoading: false,
  errorMessage: ""
};

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.SELECT_PRESCRIBE:
      return {
        ...state,
        selectedPrescribe: action.date
      };
    case TYPES.GET_ALL_PRESCRIBE_SUCCESS: {
      const prescribe = {};
      action.data.forEach(key => {
        prescribe[key] = [];
      });
      return {
        ...state,
        prescribe,
        errorMessage: ""
      };
    }
    case TYPES.GET_ALL_PRESCRIBE_FAILURE:
      return {
        ...state,
        prescribe: {},
        errorMessage: action.errorMessage
      };
    case TYPES.GET_DETAIL_PRESCRIBE_BY_DATE_SUCCESS: {
      const prescribe = { ...state.prescribe };
      prescribe[state.selectedPrescribe] = action.data;
      return {
        ...state,
        prescribe,
        errorMessage: ""
      };
    }
    case TYPES.SHOW_LOADING:
      return { ...state, showLoading: true };
    case TYPES.HIDE_LOADING:
      return { ...state, showLoading: false };
    default:
      return state;
  }
};
